 <template>
  <div class="py-4 container-fluid">
    <div class="mt-4 tag">
      <div class="col-12">
        <div class="card">
          <!-- Card header -->
          <div class="card-header border-bottom">
            <div class="tag d-flex align-items-center">
              <div class="col-6">
                <h5 class="mb-0">Regisztrált Főmérő Lista</h5>
              </div>
              <div class="col-6 text-end">
                <material-button
                    class="float-right btn btm-sm"
                    @click="this.$router.push({ name: 'Add Meter' })"
                >
                  <i class="fas fa-tag me-2"></i>
                  Mérő Hozzáadása
                </material-button>
              </div>
            </div>
          </div>

          <!-- Card body -->
          <div class="px-0 pb-0 card-body">

            <div class="table-responsive p-4">
              <!-- Table -->
              <DataTable id="dataTable" :data="data" :columns="columns" :options="dataTableOptions" ref="table"
                         class="table table-flush dataTable-table" width="100%">
                <template #action="props">
                  <td
                      class="dt-control"
                      :text="`Col 1: ${props.cellData}`"
                      @click="rowClick"
                  ></td>
                </template>
              </DataTable>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {ref} from 'vue';
import $ from "jquery";
import DataTable from 'datatables.net-vue3';
import DataTablesCore from 'datatables.net-bs5';
import eventTable from "@/mixins/eventTable.js";
import store from "@/store";
import _ from "lodash";
import MaterialButton from "@/components/MaterialButton.vue";
import MaterialInput from "@/components/MaterialInput.vue";
import BasePagination from "@/components/BasePagination.vue";
import {pagination} from "../../../consts";

DataTable.use(DataTablesCore);

var sortDirection = "created_at";

const getMetersList = _.debounce(async function (params) {
  await store.dispatch("meters/getMeters");
}, 300);

export default {
  name: "MetersList",
  components: {
    MaterialButton,
    MaterialInput,
    BasePagination,
    DataTable
  },
  mixins: [eventTable],
  setup() {
    const data = ref([]);
    const table = ref();
    const columns = [
      {
        //data: null,
        //className: 'dt-control',
        render: {
          //_: 'pod',
          display: '#action'
        },
        title: 'Action'
      },
      {title: 'POD'},
      {title: 'Gyári Szám'},
      {title: 'Beüzemelés Időpontja'},
      {title: ''},
    ];
    const dataTableOptions = ref(pagination);

    return {
      columns,
      dataTableOptions,
      data,
      table,
    }
  },
  data() {
    return {
      search: "",
      dataMeters: [],
      pagination: {},
      dataTable: null,
      keys: null
    };
  },
  computed: {
    metersList() {
      return this.$store.getters["meters/getMetersData"];
    },
    metaPage() {
      return this.$store.getters["meters/getMetersMeta"];
    },
    getAreaNumbersList() {
      return this.$store.getters["areanumbers/getAreanumbersData"];
    },
  },
  watch: {
    metersList: {
      handler: "reactiveTable",
      immediate: false,
      deep: true,
    },
  },
  async mounted() {
    await getMetersList({
      sort: sortDirection,
      query: "",
      //nr: getCurrentPage,
      //perpage: this.dataTable.options.perPage,
    });

    await this.$store.dispatch("areanumbers/getAreanumbers");

    $('#dataTable .dt-empty').html('Nincs megjeleníthető adat.');
  },
  beforeUnmount() {
    sortDirection = "created_at";
  },
  methods: {
    rowClick(event) {
      const table = $("#dataTable").DataTable();
      let tr = event.target.closest('tr');
      let row = table.row(tr);

      if (row.child.isShown()) {
        // This row is already open - close it
        row.child.hide();
      } else {
        // Open this row
        row.child(this.format(row.data())).show();
      }
    },
    format(d) {
      // `d` is the original data object for the row
      let areaHtml = "";
      areaHtml += '<table>'
      areaHtml += '<thead>'
      areaHtml += '<tr>'
      areaHtml += '<th>Szám</th>'
      areaHtml += '<th>Almérő Gyári sz.</th>'
      areaHtml += '<th>Helyrajzi szám</th>'
      areaHtml += '<th>Bruttó méret</th>'
      areaHtml += '<th></th>'
      areaHtml += '<tr>'
      areaHtml += '</thead>'

      console.log(d[0])
      if (d[0].length > 0) {
        d[0].forEach(area => {
          if (area.area_detail != null) {
            let areaNumber = this.getAreaNumbersList.find(val => String(val.id) === String(area.area_detail?.area_numbers_id));
      
            areaHtml += '<tr>'
            areaHtml += `<td class="text-center">${areaNumber.name}</td>`;
            areaHtml += `<td class="text-center">${area.submeter_detail?.product_number != undefined ? area.submeter_detail?.product_number : ''}</td>`;
            areaHtml += `<td class="text-center">${area.area_detail?.lot_number}</td>`;
            areaHtml += `<td class="text-center">${area.area_detail?.gross_floor_space}</td>`;
            areaHtml += `<td class="text-center">${this.actionDeleteButton(area?.id, "Terület törlése")}</td>`;
            areaHtml += '<tr>';
          }
        });
      }

      areaHtml += '</table>'

      return (
          `<dl>
          <dt>Szolgáltató információ:</dt>
          <dd>
          <table>
            <tr>
              <td>${d[1]}</td>
            </tr>
          </table>
          </dd>
          <dt>Helységek:</dt>
          <dd>${areaHtml}</dd>
          </dl>`
      );
    },

    async getDataFromPage(page) {
      await getMetersList({
        sort: sortDirection,
        query: this.search,
        nr: page,
        perpage: this.dataTable.options.perPage,
      });
    },

    async reactiveTable() {
      this.dataMeters = [];
      if (this.metersList.length > 0) {
        this.metersList.forEach((meter) => {
          this.dataMeters.push([
            meter.areas,
            meter.unetwork.pod,
            meter.product_number,
            meter.commissioning_date,

            `<div class="text-end">${
                this.actionEditButton(meter.id, "Főmérő módosítása") +
                this.actionDeleteButton(meter.id, "Főmérő törlése")
            }</div>`,
          ]);
        });

        this.data = this.dataMeters;
        this.removeEvent();
        await this.$nextTick();
        this.eventToCall({
          myUserId: null,
          redirectPath: "Edit Meter",
          deletePath: "meters/deleteMeter",
          getPath: "meters/getMeters",
          textDelete: "Főmérő sikeresen törölve!",
          textDefaultData: "meters",
        });
      }
    },
  },
};
</script>

<style scoped lang="css">
@import 'datatables.net-bs5';
</style>
